import { Component } from '@angular/core';
import { SessionService } from 'src/app/features/shared/services/Session.service';

@Component({
  selector: 'downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css']
})
export class DownloadsComponent {
  constructor(private sessionService: SessionService) { }
  
    ngOnInit(): void {
      this.sessionService.setIsExternalMap(false);
    }
}
